import {dateTimeUtil} from '../../../../../../utils';

const config = [
    {
        headerKey: 'user:user.identity.type',
        prop: 'identityType'
    },
    {
        headerKey: 'user:user.identity.value',
        prop: 'value'
    },
    {
        headerKey: 'user:user.identity.description',
        prop: 'description'
    },
    {
        headerKey: 'user:user.identity.active',
        prop: 'active',
        transform: identity => identity.active ? 'Yes' : 'No'
    },
    {
        headerKey: 'user:user.identity.not.before',
        prop: 'notBefore',
        type: 'datetime',
        transform: identity => {
            if (identity.notBefore) {
                return dateTimeUtil.toDisplayDateTime(identity.notBefore);
            }
            return null;
        }
    },
    {
        headerKey: 'user:user.identity.not.after',
        prop: 'notAfter',
        type: 'datetime',
        transform: identity => {
            if (identity.notAfter) {
                return dateTimeUtil.toDisplayDateTime(identity.notAfter);
            }
            return null;
        }
    },
    {
        headerKey: 'user:user.identity.created.at',
        prop: 'createdAt',
        type: 'datetime',
        transform: identity => {
            if (identity.createdAt) {
                return dateTimeUtil.toDisplayDateTime(identity.createdAt);
            }
            return null;
        }
    },
    {
        headerKey: 'user:user.identity.updated.at',
        prop: 'updatedAt',
        type: 'datetime',
        transform: identity => {
            if (identity.updatedAt) {
                return dateTimeUtil.toDisplayDateTime(identity.updatedAt);
            }
            return null;
        }
    }
];
export default config;
